import { Collapse, Form } from 'antd';
import './RightInsideDesignMenu.scss';
import InputComponent from '../../common/InputComponent/InputComponent';
import { Icon } from '../../icon/icon';
import { useContext, useEffect, useState } from 'react';
import { DesignerPageContext } from '../../../pages/DesignerPage/DesignerPage';
import RightMenuDesign from '../../house/RightMenuDesign/RightMenuDesign';
import ButtonTertiarySmall from '../../common/ButtonTertiary/ButtonTertiarySmall';
import { Popconfirm } from 'antd';
import { Divider } from 'antd';
import ButtonPrimarySmall from '../../common/ButtonPrimary/ButtonPrimarySmall';
import { GeometryUtils } from '../../../utils/geometry/GeometryUtils';
import { message } from 'antd';
import { InsideType } from '../../../constants/enum';
import { getInputType } from '../../../utils/string/inputExpression';
import { openMessageError } from '../../common/Message/openMessageError';
import { openMessageWarning } from '../../common/Message/openMessageWarning';
import { openMessageSuccess } from '../../common/Message/openMessageSuccess';
import InsideCabinetHandler from '../../../three/core/handlers/InsideCabinetHandler';
import { useTranslation } from 'react-i18next';
import Chip from '../../common/Chip/Chip';

const RightInsideDesignMenu = ({ open, form, className }) => {
  const { t } = useTranslation();
  const designerPageContext = useContext(DesignerPageContext);
  const [duplicateCount, setDuplicateCount] = useState(1);
  const [insideType, setInsideType] = useState(null);
  const { insideLoaderRef, sceneManager, setTick, meshClickRef } =
    designerPageContext;

  const [insideKey, setInsideKey] = useState(null);

  useEffect(() => {
    if (open && sceneManager) {
      switch (meshClickRef.current.userData?.type) {
        // case 1:
        // case 0:
        //   setInsideKey('plank');
        //   break;
        case 3:
          setInsideKey('drawer');
          break;
        case 4:
          setInsideKey('uDrawer');
          break;
        default:
          setInsideKey(null);
          break;
      }

      if (meshClickRef?.current) {
        setInsideType(meshClickRef.current.userData?.type);
        if (meshClickRef.current.userData?.type === InsideType.U_DRAWER) {
          const count =
            meshClickRef.current.userData.infoChildDrawer?.numDrawer || 2;
          const height =
            meshClickRef.current.userData.infoChildDrawer?.heightDrawer || 0.1;

          const model = GeometryUtils.findTopLevelParent(meshClickRef.current);
          const currentCabinet =
            sceneManager.cabinetManager.getCurrentCabinet();
          const foundModule = currentCabinet?.getModuleByGroupUuid(model?.uuid);

          let uDrawerSize = { x: 0, y: 0, z: 0 };
          if (foundModule && meshClickRef.current) {
            uDrawerSize = GeometryUtils.getSizeRotation(
              foundModule.group,
              meshClickRef.current
            );
          }

          form.setFieldsValue({
            uDrawerCount: Math.round(count),
            uDrawerHeight: Math.round(height * 1000),
            uDrawerWidth: Math.round(uDrawerSize.x * 1000),
            uDrawerDepth: Math.round(uDrawerSize.z * 1000),
            uDrawerTotalHeight: Math.round(uDrawerSize.y * 1000),
          });
        } else if (meshClickRef.current.userData?.type === InsideType.DRAWER) {
          const model = GeometryUtils.findTopLevelParent(meshClickRef.current);
          const currentCabinet =
            sceneManager.cabinetManager.getCurrentCabinet();
          const foundModule = currentCabinet?.getModuleByGroupUuid(model?.uuid);

          let size = { x: 0, y: 0, z: 0 };
          if (foundModule && meshClickRef.current) {
            size = GeometryUtils.getSizeRotation(
              foundModule.group,
              meshClickRef.current
            );
          }

          form.setFieldsValue({
            widthDrawer: Math.round(size.z * 1000),
            heightDrawer: Math.round(size.y * 1000),
            depthDrawer: Math.round(size.x * 1000),
          });
          setInsideKey('drawer');
        }
      }
    }
  }, [open, sceneManager, meshClickRef.current]);

  const handleApplyUDrawer = async () => {
    const values = form.getFieldsValue();
    const { uDrawerCount } = values; // Lấy giá trị từ form

    if (!insideLoaderRef.current || !sceneManager) {
      console.error('InsideLoader or SceneManager not available');
      return;
    }

    try {
      const model = GeometryUtils.findTopLevelParent(meshClickRef.current);
      const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
      const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

      if (!foundModule) {
        console.error('No module selected');
        return;
      }

      const orientation = GeometryUtils.getModuleOrientation(foundModule.group);
      const sizeXDrawerChild =
        meshClickRef.current.userData.infoChildDrawer.sizeXDrawerChild;
      const originalSize = GeometryUtils.getSizeRotation(
        foundModule.group,
        meshClickRef.current
      );
      const bottomGap =
        meshClickRef.current.userData.infoChildDrawer?.bottomGap || 0;
      const topGap = meshClickRef.current.userData.infoChildDrawer?.topGap || 0;

      if (getInputType(uDrawerCount) === 'number')
        // Gọi hàm settingUdrawer từ InsideLoader
        await insideLoaderRef.current.settingUDrawer(
          foundModule,
          sizeXDrawerChild,
          parseInt(uDrawerCount) || 2, // Số lượng hộc
          bottomGap,
          topGap,
          originalSize,
          meshClickRef.current,
          orientation
        );

      const count =
        meshClickRef.current.userData.infoChildDrawer?.numDrawer || 2;
      const height =
        meshClickRef.current.userData.infoChildDrawer?.heightDrawer || 0.1;
      form.setFieldsValue({
        uDrawerCount: Math.round(count), // Làm tròn số nguyên
        uDrawerHeight: Math.round(height * 1000), // Làm tròn số nguyên (mm)
      });

      // Trigger re-render
      setTick(tick => tick + 1);

      // Có thể thêm thông báo thành công
      console.log('U-Drawer settings applied successfully');
    } catch (error) {
      console.error('Error applying U-Drawer settings:', error);
    }
  };

  const handleChangeUDrawerHeight = async newHeight => {
    if (!insideLoaderRef.current || !sceneManager || !meshClickRef.current) {
      openMessageError({ content: t("Can't change height") });
      return;
    }

    // Validation
    if (newHeight < 100) {
      openMessageWarning({
        content: t('Minimum height is {{x}}mm', { x: 100 }),
      });
      return;
    }

    try {
      const model = GeometryUtils.findTopLevelParent(meshClickRef.current);
      const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
      const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

      if (!foundModule) {
        openMessageError({ content: t('Module not found') });
        return;
      }

      // Hiển thị loading
      const hide = message.loading(t('Updating height'), 0);

      // Gọi hàm scale height
      await insideLoaderRef.current.scaleUDrawerHeight(
        foundModule,
        meshClickRef.current,
        newHeight / 1000 // Convert mm to m
      );

      hide();

      // Cập nhật lại form với giá trị mới
      const count =
        meshClickRef.current.userData.infoChildDrawer?.numDrawer || 2;
      const height =
        meshClickRef.current.userData.infoChildDrawer?.heightDrawer || 0.1;
      const newSize = GeometryUtils.getSizeRotation(
        foundModule.group,
        meshClickRef.current
      );

      form.setFieldsValue({
        uDrawerCount: Math.round(count),
        uDrawerHeight: Math.round(height * 1000),
        uDrawerTotalHeight: Math.round(newSize.y * 1000),
      });

      setTick(tick => tick + 1);
      openMessageSuccess({ content: t('Height updated successfully') });
    } catch (error) {
      console.error('Error changing U-Drawer height:', error);
      openMessageError({
        content: t('Cannot change height: {{message}}', {
          message: error.message,
        }),
      });
    }
  };

  const handleChangeDrawerHeight = async newHeight => {
    if (!insideLoaderRef.current || !sceneManager || !meshClickRef.current) {
      openMessageError({ content: t("Can't change height") });
      return;
    }

    // Validation
    if (newHeight < 17) {
      openMessageWarning({
        content: t('Minimum height is {{x}}mm', { x: 17 }),
      });
      return;
    }

    try {
      const model = GeometryUtils.findTopLevelParent(meshClickRef.current);
      const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
      const foundModule = currentCabinet?.getModuleByGroupUuid(model?.uuid);

      if (!foundModule) {
        openMessageError({ content: t('Module not found') });
        return;
      }

      // Hiển thị loading
      const hide = message.loading(t('Updating height'), 0);
      InsideCabinetHandler.scaleHeight(
        meshClickRef.current,
        (newHeight - 8) / 1000
      );

      hide();

      const newSize = GeometryUtils.getSizeRotation(
        foundModule.group,
        meshClickRef.current
      );

      form.setFieldsValue({
        widthDrawer: Math.round(newSize.z * 1000),
        heightDrawer: Math.round(newSize.y * 1000),
        depthDrawer: Math.round(newSize.x * 1000),
      });

      setTick(tick => tick + 1);
      openMessageSuccess({ content: t('Height updated successfully') });
    } catch (error) {
      console.error('Error changing U-Drawer height:', error);
      openMessageError({
        content: t('Cannot change height: {{message}}', {
          message: error.message,
        }),
      });
    }
  };

  const handleDuplicateEvenly = async () => {
    if (!insideLoaderRef.current || !sceneManager || !meshClickRef.current) {
      message.error(t("Can't duplicate"));
      return;
    }

    // Validation số lượng
    if (!duplicateCount || duplicateCount < 1) {
      message.warning(t('Quantity must be greater than 0'));
      return;
    }

    if (duplicateCount > 20) {
      message.warning(t('Maximum quantity is 20'));
      return;
    }

    try {
      const model = GeometryUtils.findTopLevelParent(meshClickRef.current);
      const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
      const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

      if (!foundModule) {
        message.error('Không tìm thấy module');
        return;
      }

      // Xác định insideType
      const currentInsideType = meshClickRef.current.userData.type;

      // Kiểm tra xem có hỗ trợ nhân bản không
      const supportedTypes = [
        InsideType.DRAWER,
        InsideType.HPANEL,
        InsideType.VPANEL,
        InsideType.VPANEL2,
        InsideType.HPANEL_RIGHT,
        InsideType.HPANEL_LEFT,
      ];
      if (!supportedTypes.includes(currentInsideType)) {
        message.warning('Loại phần tử này chưa hỗ trợ nhân bản');
        return;
      }

      // Gọi hàm nhân bản đều
      await insideLoaderRef.current.duplicateEvenly(
        meshClickRef.current,
        duplicateCount,
        currentInsideType,
        foundModule,
        currentCabinet
      );

      await sceneManager.calculateTotalCost?.({});

      setTick(tick => tick + 1); // Update scene
      message.success(t('Duplicated {{x}} elements', { x: duplicateCount }));
    } catch (error) {
      console.error('Error duplicating:', error);
      message.error(t("Can't duplicate") + ': ' + error.message);
    }
  };

  const formForCurrentCabinet = {
    partitionPlate: [
      {
        key: 'horizontalBoard1',
        label: <span className="text-title-medium">{t('Size')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item name={'width'} label={t('Width')}>
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item name={'depth'} label={t('Depth')}>
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item name={'height'} label={t('Height')}>
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
          </div>
        ),
      },
    ],
    drawer: [
      {
        key: 'drawer1',
        label: <span className="text-title-medium">{t('Size')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item name={'widthDrawer'} label={t('Width')}>
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item name={'depthDrawer'} label={t('Depth')}>
              <div className="flex items-center gap-4">
                <InputComponent
                  addonAfter={<span className="text-body-medium">mm</span>}
                  placeholder={t('Enter')}
                />
              </div>
            </Form.Item>
            <Form.Item name={'heightDrawer'} label={t('Height')}>
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                onChange={e => {
                  if (getInputType(e.target.value) === 'number') {
                    const newValue = parseInt(e.target.value);
                    if (!isNaN(newValue) && newValue >= 17) {
                      // Debounce để tránh gọi quá nhiều lần
                      if (window.drawerHeight) {
                        clearTimeout(window.drawerHeight);
                      }
                      window.drawerHeight = setTimeout(() => {
                        handleChangeDrawerHeight(newValue);
                      }, 500); // Đợi 500ms sau khi user ngừng nhập
                    }
                  }
                }}
              />
            </Form.Item>
          </div>
        ),
      },
      {
        key: 'drawer2',
        label: <span className="text-title-medium">{t('Layout')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Top edge distance')}>
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
            </Form.Item>
            <Form.Item label={t('Bottom edge distance')}>
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
            </Form.Item>
          </div>
        ),
      },
    ],
    uDrawer: [
      {
        key: 'uDrawer1',
        label: <span className="text-title-medium">{t('Size')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Length')} name="uDrawerWidth">
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item label={t('Depth')} name="uDrawerDepth">
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item label={t('Height')} name="uDrawerTotalHeight">
              <InputComponent
                step={10} // Bước nhảy 10mm
                min={100} // Chiều cao tối thiểu
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={false} // Cho phép chỉnh sửa
                // Thêm onChange với debounce
                onChange={e => {
                  if (getInputType(e.target.value) === 'number') {
                    const newValue = parseInt(e.target.value);
                    if (!isNaN(newValue) && newValue >= 100) {
                      // Debounce để tránh gọi quá nhiều lần
                      if (window.uDrawerHeightTimeout) {
                        clearTimeout(window.uDrawerHeightTimeout);
                      }
                      window.uDrawerHeightTimeout = setTimeout(() => {
                        handleChangeUDrawerHeight(newValue);
                      }, 500); // Đợi 500ms sau khi user ngừng nhập
                    }
                  }
                }}
              />
            </Form.Item>
          </div>
        ),
      },
      {
        key: 'uDrawer2',
        label: <span className="text-title-medium">Hộc tủ</span>,
        children: (
          <div className="flex flex-col gap-16 items-end self-stretch">
            <div className="flex items-center gap-16 self-stretch flex-col">
              <Form.Item
                name="uDrawerCount"
                label={<span className="text-label-medium">Số lượng</span>}
              >
                <InputComponent
                  addonAfter={<span className="text-body-medium">cái</span>}
                  placeholder={'Nhập'}
                  min={1}
                />
              </Form.Item>
              <Form.Item
                name="uDrawerHeight"
                label={<span className="text-label-medium">Chiều cao</span>}
              >
                <InputComponent
                  type={'number'}
                  disabled={true}
                  addonAfter={<span className="text-body-medium">mm</span>}
                  placeholder={'Nhập'}
                  min={0}
                />
              </Form.Item>
            </div>
            <ButtonPrimarySmall
              title={'Áp dụng'}
              onClick={handleApplyUDrawer}
            />
          </div>
        ),
      },
    ],
  };

  const formInside = insideKey ? (formForCurrentCabinet[insideKey] ?? []) : [];

  // useEffect(() => {
  //   form.setFieldsValue({
  //     width: cabinetEditorContext.mdCustomData.mdDimensions.width * 1000,
  //     height: cabinetEditorContext.mdCustomData.mdDimensions.height * 1000,
  //     depth: cabinetEditorContext.mdCustomData.mdDimensions.depth * 1000,
  //   });
  // }, [open]);

  return (
    <RightMenuDesign
      open={open}
      classNames={{
        root: 'top-16 ' + className,
        content: '!p-0 gap-0',
      }}
      header={
        <span className="text-title-large text-nowrap">{t('Customize')}</span>
      }
      content={
        <>
          <Form
            form={form}
            labelAlign="left"
            labelWrap
            labelCol={{ flex: '100px' }}
            colon={false}
            layout="horizontal"
            validateTrigger={'onChange'}
            className="left-cabinet-design-menu-body flex flex-col items-start overflow-hidden p-8 gap-8 grow self-stretch"
          >
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={[
                'drawer1',
                'drawer2',
                'uDrawer1',
                'uDrawer2',
                'duplicate',
                'horizontalBoard1',
              ]}
              onChange={() => {}}
              className="self-stretch overflow-auto"
              items={[
                ...([0, 1, 11].includes(insideType)
                  ? formForCurrentCabinet.partitionPlate
                  : [3].includes(insideType)
                    ? formForCurrentCabinet.drawer
                    : [4].includes(insideType)
                      ? formForCurrentCabinet.uDrawer
                      : []),
                {
                  key: 'duplicate',
                  label: (
                    <span className="text-title-medium">
                      {t('Duplicate evenly')}
                    </span>
                  ),
                  children: (
                    <div className="flex flex-col gap-16 items-end self-stretch">
                      <Form.Item label={t('Quantity')}>
                        <InputComponent
                          placeholder={t('Enter')}
                          type="number"
                          value={duplicateCount}
                          onChange={e => {
                            const val = parseInt(e.target.value);
                            setDuplicateCount(val);
                          }}
                        />
                      </Form.Item>
                      <ButtonPrimarySmall
                        title={t('Apply')}
                        onClick={handleDuplicateEvenly}
                      />
                    </div>
                  ),
                },
              ].map(item => ({
                ...item,
                onKeyDown: e => {
                  e.stopPropagation();
                },
              }))}
            />
          </Form>
        </>
      }
    />
  );
};

export default RightInsideDesignMenu;
